import mockBdd from "utils/mock";
import Auth from "./auth";

export const axiosInstance = async () => {
  // await new Promise((resolve, reject) => {setTimeout(() => resolve(), 2000)});
  const user = await Auth.getUser();
  const { id_token: token } = user || { id_token: "000.000.000-01" };
  if (!token) {
    return mockBdd["000.000.000-01"];
  }
  const mock = mockBdd[token];
  return mock;
};
